import { useCallback, useEffect, useRef, useState } from 'react';

import { isVideo } from '../../utils/isVideo';

export const useSequentialVideos = (
  media: string[]
): {
  currentVideoIndex: number;
  handleVideoEnd: () => void;
  videoRefs: React.MutableRefObject<(HTMLVideoElement | null)[]>;
} => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);

  const findNextVideoIndex = useCallback(
    (currentIndex: number): number => {
      let nextIndex = (currentIndex + 1) % media.length;
      const startIndex = currentIndex;

      while (!isVideo(media[nextIndex])) {
        nextIndex = (nextIndex + 1) % media.length;
        if (nextIndex === startIndex) break;
      }
      return nextIndex;
    },
    [media]
  );

  const handleVideoEnd = useCallback(() => {
    setCurrentVideoIndex((prevIndex) => findNextVideoIndex(prevIndex));
  }, [findNextVideoIndex]);

  useEffect(() => {
    const currentVideo = videoRefs.current[currentVideoIndex];
    if (currentVideo && isVideo(media[currentVideoIndex])) {
      currentVideo.play();
    }
  }, [currentVideoIndex, media]);

  return { currentVideoIndex, handleVideoEnd, videoRefs };
};
